import { featuredMediaConfigFields } from 'molecules/FeaturedMedia/config';
import { featuredTextFields } from 'molecules/FeaturedText/config';

import type { Input } from '@builder.io/sdk';

export const calloutSwitchbackFields = [
  {
    name: 'textPosition',
    type: 'string',
    enum: ['left', 'right'],
    defaultValue: 'left',
  },
  {
    name: 'featuredText',
    type: 'object',
    subFields: featuredTextFields,
  },
  {
    name: 'featuredMedia',
    type: 'object',
    subFields: featuredMediaConfigFields,
  },
] as const satisfies DeepReadonly<Input[]>;

const calloutSwitchbackConfig = {
  name: 'Callout Switchback',
  inputs: calloutSwitchbackFields,
};

export type CalloutSwitchbackProps = GenerateBuilder<typeof calloutSwitchbackFields>;

export default calloutSwitchbackConfig;
